import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosGet from "../axios/axios-get";
import axiosPut from "../axios/axios-put";

const BASE_URL = "/orders";

export const OrdersAPI = Object.freeze({
  getAll: createAsyncThunk(
    "get/get-orders",
    async (params, { rejectWithValue }) => {
      try {
        const response = await axiosGet.get(BASE_URL, { params });

        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),

  getOne: createAsyncThunk("get/one-order", async (id, { rejectWithValue }) => {
    try {
      const response = await axiosGet.get(`${BASE_URL}/${id}`);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }),
  updateTransactionStatus: createAsyncThunk(
    "orders/update-transaction-status",
    async ({ id, transaction_status }, { rejectWithValue }) => {
      try {
        const payload = { transaction_status };
        const response = await axiosPut.put(`${BASE_URL}/${id}`, payload);
        return response.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  ),
});
